import { robPersonQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import { usePersonStore } from '@gov-nx/store';

interface SupportDataLoader {
	isEnabled: boolean;
}

export const usePoSupportDataLoad = (props?: SupportDataLoader) => {
	const communication = usePersonStore('communication');
	const individualPerson = usePersonStore('individual');
	const setIndividualPersonData = usePersonStore('setIndividualPersonData');
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: ['osoby', 'fyzicke'],
		queryFn: async () => robPersonQuery(axiosInstance),
		onSuccess: (data) => setIndividualPersonData(data),
		refetchOnWindowFocus: false,
		retry: 0,
		enabled: props?.isEnabled,
	});

	return {
		individualPerson,
		communication,
		isLoading: query.isLoading,
		error: query.error,
	};
};
